module.exports = __webpack_public_path__ + "static/media/Share.4dd63edc.svg";